import { es } from 'vuetify/es5/locale';

export default {
  ...es,
};



// WEBPACK FOOTER //
// ./src/i18n/es.js